import axios from '../http'
import global from '@/constants/Global.constants'

export default {
  getAllGoodsType(params) { // 获取商品分类
    return axios.post(global.DMZ_PMC + '/info/type/findAllProductTypeTree', params)
  },
  getGoodsTop(params) { // 获取热销前八
    return axios.post(global.MSI_PPRODUCT + '/product/findProductInfoPriceTop8', params)
  },
  getGoodsDetail(params) { // 获取商品详情
    return axios.post(global.DMZ_PMC + '/info/product/findEcProductInfoDetail', params)
    //return axios.post('http://192.168.9.61:5011/dmz/pmc/info/product/findEcProductInfoDetail', params)
  },
  // 特价
  getGoodsDetail2(params) { // 获取商品详情
    return axios.post(global.DMZ_PMC + '/info/product/findEcProductBargainsDetail', params)
    //return axios.post('http://192.168.9.61:5011/dmz/pmc/info/product/findEcProductInfoDetail', params)
  },
  getGoodsDetail3(params) { // 获取商品详情
    return axios.post(global.DMZ_PMC + '/info/product/findEcProductBargainsDetailVc', params)
    //return axios.post('http://192.168.9.61:5011/dmz/pmc/info/product/findEcProductInfoDetail', params)
  },
  getGiftDetail(params) { // 获取礼品详情
    return axios.post(global.MMC_GIFT + '/findGift', params)
    //return axios.post('http://192.168.9.61:5011/dmz/pmc/info/product/findEcProductInfoDetail', params)
  },
  getCartList(params) { // 获取购物车列表
    return axios.post(global.IMS_ORDER + '/sale/cart/findImsSaleCartPage', params)
  },
  addToCart(params) { // 添加购物车
    return axios.post(global.IMS_ORDER + '/sale/cart/insertCart', params)
  },
  addToCartList(params) { // 添加购物车
    return axios.post(global.IMS_ORDER + '/sale/cart/batchInsertCart', params)
  },
  updateCartQuantity(params) { // 更新购物车数量
    return axios.post(global.IMS_ORDER + '/sale/cart/updateCartItem', params)
  },
  deleteCart(params) { // 删除购物车
    return axios.post(global.IMS_ORDER + '/sale/cart/deleteCart', params)
  },
  clearCart(params) { // 清空购物车
    return axios.post(global.IMS_ORDER + '/sale/cart/emptyCart', params)
  },
  checkout(params) { // 结算
    return axios.post(global.IMS_ORDER + '/sales/insertOrder', params)
  },
  checkoutOnline(params) { // 结算
    return axios.post(global.IMS_ORDER + '/sales/insertOnlineOrder', params)
  },
  updateOrder(params) { // 编辑结算
    return axios.post(global.IMS_ORDER + '/sales/updateOrder', params)
  },
  addToWishlist(params) { // 添加收藏夹
    return axios.post(global.CMS_FAVORITES + '/insertFavorites', params)
  },
  getWishlist(params) { // 获取收藏夹列表
    return axios.post(global.CMS_FAVORITES + '/findAll', params)
  },
  deleteWishlist(params) { // 移除收藏夹
    return axios.post(global.CMS_FAVORITES + '/cancelFavorites', params)
  },
  findAllExchangeCart(params) { // 兑换商城查询购物车列表
    return axios.post(global.MMC_EXCHANGE + '/exchangCart/findAllExchangeCart', params)
  },
  insertExchangeCart(params) { // 兑换商城添加购物车
    return axios.post(global.MMC_EXCHANGE + '/exchangCart/insertExchangeCart', params)
  },
  updateExchangeCart(params) { // 兑换商城编辑购物车
    return axios.post(global.MMC_EXCHANGE + '/exchangCart/updateExchangeCart', params)
  },
  deleteExchangeCart(params) { // 兑换商城删除购物车
    return axios.post(global.MMC_EXCHANGE + '/exchangCart/deleteExchangeCart', params)
  },
  insertExchangeOrder(params) { // 兑换商城购物车结算
    return axios.post(global.MMC_EXCHANGE + '/exchangOrder/insertExchangeOrder', params)
  },
  ecLoadBaseAsp(params) { // 获取公司logo
    return axios.post(global.EC_BASE_INFO + '/asp/loadBaseAsp', params)
  },
  loadBaseAsp(params) { // 获取公司logo
    return axios.post(global.DMZ_BASE_INFO + '/asp/loadBaseAsp', params)
  },

}



// WEBPACK FOOTER //
// ./src/request/pmc/goods.js